import { render, staticRenderFns } from "./info-hub-outline.vue?vue&type=template&id=37120730&"
var script = {}
import style0 from "./info-hub-outline.vue?vue&type=style&index=0&id=37120730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports